class SiblingOption extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("load", this.rerunAfterpayStyling);
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      const handle = this.getAttribute("data-handle");
      this.url = this.querySelector("a")?.href;
      this.fetchMainProductHtml(handle);
    });
  }

  fetchMainProductHtml(handle) {
    const destinationUrl = this.url
      ? this.url + `&section_id=${this.dataset.section}`
      : `/products/${handle}?section_id=${this.dataset.section}`;

    fetch(destinationUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `shopify-section-${this.dataset.section}`;
        const html = this.parseResponse(responseText);
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const variantData = html.getElementById(
          "additionalVariantData"
        ).textContent;
        const productsJsonData = variantData ? JSON.parse(variantData) : {};

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          const productFormVariantIDElement =
            source.querySelector("[name='id']");

          if (productFormVariantIDElement) {
            const currentVariantID = productFormVariantIDElement.value;
            const currentVariant = productsJsonData[currentVariantID];
            // Update variation selections based on previous options from other range if possible
            if (currentVariant) {
              for (const optionName in currentVariant.options) {
                const inputForOptionValue = document.querySelector(
                  `input[name="${optionName}"][value="${currentVariant.options[optionName]}"]`
                );

                if (inputForOptionValue) {
                  inputForOptionValue.checked = true;
                } else {
                  console.warn(
                    `Input for option ${optionName} value ${currentVariant.options[optionName]} not found.`
                  );
                }
              }
            }
          }

          // // Loyalty lion only sends requests on page load not fetches
          // destination.querySelector(".calculated-loyalty-points").innerHTML =
          //   calculatedLoyaltyPoints;

          document.dispatchEvent(
            new Event("VariantAutoselected", { bubbles: false })
          );
          this.updateUrl();
          this.reinitializePotentialEarnings();
          this.rerunAfterpayStyling();
          this.rerunModalScripts();
          
        }
      })
      .catch((e) => {
        console.log("ERRR", e);
        window.location.href = this.url;
      });
  }

  parseResponse(responseText) {
    /*
        Handles a wacky edge case observed on a handful of iOS devices.
        Occasionally parsing the response text fails and only includes the content up to the variant-radios section.
        Unbelievably this parsing operation is NOT IDEMPOTENT, leading to intermittent observation of the bug.
        This logic attempts to parse the response up three times. In practice I've never seen this need more than 2 attempts to work.
      */
    const domParser = new DOMParser();
    let html = domParser.parseFromString(responseText, "text/html");
    const htmlIsMissingProductForm =
      html.getElementsByTagName("product-form").length === 0;

    if (htmlIsMissingProductForm) {
      console.warn("Failed to fully parse main section HTML. Trying again.");
      const html2 = domParser.parseFromString(responseText, "text/html");
      const html2IsMissingProductForm =
        html2.getElementsByTagName("product-form").length === 0;

      if (html2IsMissingProductForm) {
        console.warn(
          "Failed to fully parse main section HTML twice. Trying one final time."
        );
        const html3 = domParser.parseFromString(responseText, "text/html");
        const html3IsMissingProductForm =
          html3.getElementsByTagName("product-form").length === 0;

        if (html3IsMissingProductForm) {
          console.error("Failed to parse main section HTML three times.");
          throw Error;
        } else {
          html = html3;
        }
      } else {
        html = html2;
      }
    }

    return html;
  }

  updateUrl() {
    window.history.replaceState({}, "", this.url);
  }

  rerunAfterpayStyling() {
    const script = document.getElementById("afterpay-pdp");
    eval(script.innerHTML);
  }

  rerunModalScripts() {
    // If the merchant has added any scripts to their size-chart we need to run them
    // again after changing size range
    const modals = Array.from(document.getElementsByTagName("modal-dialog"));
    modals.forEach((modal) => {
      const scripts = Array.from(modal.getElementsByTagName("script"));
      scripts.forEach((script) => {
        eval(script.innerHTML);
      });
    });
  }

  reinitializePotentialEarnings() {
    if (window.zrl_mi) {
      zrl_mi.on_successful_product_points_fetch();
    }
  }
}

customElements.define("sibling-option", SiblingOption);
  